import { Phone, MessageCircle, MapPin, ParkingCircle, Clock, UserCircle } from "lucide-react";
import { PHONE, PHONE_TEL, WA_LINK, ADDRESS, MAP_EMBED, HOURS, PROP_PHONE, PROP_PHONE_TEL } from "../data/menuData";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="bg-[#FAFAFA] border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="max-w-3xl mb-10 md:mb-14">
          <div className="inline-block brutal-border bg-[#D92525] text-white px-3 py-1 text-xs font-bold uppercase tracking-widest mb-4">
            Visit / Order
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] text-black">
            Visit us in <span className="text-[#D92525]">Bangarpet</span>,
            <br /> or place an order!
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-6">
          {/* Map */}
          <div
            data-testid="contact-map-wrapper"
            className="lg:col-span-7 brutal-border brutal-shadow-lg overflow-hidden aspect-[4/3] lg:aspect-auto lg:min-h-[460px] bg-white"
          >
            <iframe
              title="KKFC Bangarpet Location"
              src="https://www.google.com/maps?q=Bangarpet,Karnataka&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 460 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>

          {/* Info */}
          <div className="lg:col-span-5 flex flex-col gap-5">
            <div className="brutal-border brutal-shadow bg-[#FFB800] p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 brutal-border bg-black flex items-center justify-center shrink-0">
                  <MapPin size={20} strokeWidth={2.5} color="#FFB800" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-widest text-neutral-800">
                    Address
                  </div>
                  <div className="font-display text-2xl md:text-3xl uppercase text-black leading-tight">
                    KKFC Bangarpet
                  </div>
                  <div className="text-sm mt-1 text-neutral-900 leading-snug">
                    {ADDRESS}
                  </div>
                </div>
              </div>
            </div>

            <div className="brutal-border brutal-shadow bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 brutal-border bg-black flex items-center justify-center shrink-0">
                  <UserCircle size={20} strokeWidth={2.5} color="#FFB800" />
                </div>
                <div className="flex-1">
                  <div className="text-[11px] uppercase tracking-widest text-neutral-700">
                    Proprietor
                  </div>
                  <div className="font-display text-2xl uppercase text-black leading-tight">
                    Direct Line
                  </div>
                  <a
                    href={`tel:${PROP_PHONE_TEL}`}
                    data-testid="contact-prop-call"
                    className="text-sm mt-1 text-[#D92525] font-bold inline-flex items-center gap-2 hover:underline"
                  >
                    <Phone size={14} /> {PROP_PHONE}
                  </a>
                  <div className="text-xs mt-1 text-neutral-600">
                    For bulk orders, pre-orders & special requests.
                  </div>
                </div>
              </div>
            </div>

            <div className="brutal-border brutal-shadow bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 brutal-border bg-[#D92525] flex items-center justify-center shrink-0">
                  <ParkingCircle size={20} strokeWidth={2.5} color="#FFFFFF" />
                </div>
                <div>
                  <div className="text-[11px] uppercase tracking-widest text-neutral-700">
                    Parking
                  </div>
                  <div className="font-display text-2xl uppercase text-black leading-tight">
                    Free Street Parking
                  </div>
                  <div className="text-sm mt-1 text-neutral-700">
                    Plenty of space for bikes, scooters and cars.
                  </div>
                </div>
              </div>
            </div>

            <div className="brutal-border brutal-shadow bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 brutal-border bg-black flex items-center justify-center shrink-0">
                  <Clock size={20} strokeWidth={2.5} color="#FFB800" />
                </div>
                <div className="flex-1">
                  <div className="text-[11px] uppercase tracking-widest text-neutral-700">
                    Hours
                  </div>
                  <div className="font-display text-2xl uppercase text-black leading-tight">
                    Open 7 Days
                  </div>
                  <ul className="mt-2 space-y-1 text-sm text-neutral-800">
                    {HOURS.map((h) => (
                      <li key={h.day} className="flex justify-between gap-3">
                        <span className="font-semibold">{h.day}</span>
                        <span className="text-neutral-700">{h.time}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="text-xs mt-2 text-neutral-600">
                    Open all 7 days · Home delivery min ₹300 + ₹45 · Parcel ₹10 extra.
                  </div>
                </div>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-3">
              <a
                href={`tel:${PHONE_TEL}`}
                data-testid="contact-call-btn"
                className="inline-flex items-center justify-center gap-2 brutal-border brutal-shadow bg-[#D92525] text-white font-bold px-5 py-4 text-sm uppercase tracking-widest"
              >
                <Phone size={18} strokeWidth={2.5} />
                Call {PHONE}
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid="contact-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 brutal-border brutal-shadow bg-[#25D366] text-black font-bold px-5 py-4 text-sm uppercase tracking-widest"
              >
                <MessageCircle size={18} strokeWidth={2.5} />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
